export enum INCIDENCE_SOLUTION_TYPE {
  REFUND = 'REFUND',
  REPLACEMENT = 'REPLACEMENT',
  EXCHANGE = 'EXCHANGE',
}

export const INCIDENCE_SOLUTIONS_VALUES = Object.values(INCIDENCE_SOLUTION_TYPE);

export enum REFUND_TYPE_ENUM {
  TOTAL = 'TOTAL',
  PARTIAL = 'PARTIAL',
}

export const refundTypeValues = Object.values(REFUND_TYPE_ENUM);

export enum REFUND_METHOD_ENUM {
  CREDIT_CARD = 'CREDIT_CARD',
  INTERNAL_WALLET = 'INTERNAL_WALLET',
  BANK_TRANSFER = 'BANK_TRANSFER',
}

export const refundMethodValues = Object.values(REFUND_METHOD_ENUM);

export const SOLUTION_TYPE_MAP = {
  [INCIDENCE_SOLUTION_TYPE.REFUND]: 'money-refund',
  [INCIDENCE_SOLUTION_TYPE.EXCHANGE]: 'product-change',
  [INCIDENCE_SOLUTION_TYPE.REPLACEMENT]: 'product-replace',
};

export enum CostKind {
  SHIPPING = 'SHIPPING',
  HANDLING = 'HANDLING',
  PRICE_DIFF = 'PRICE_DIFF',
  LOST_GOODS = 'LOST_GOODS',
  OTHER = 'OTHER',
}

export enum ChargeReason {
  WRONG_PRODUCT = 'WRONG_PRODUCT',
  CHANGE_OF_MIND = 'CHANGE_OF_MIND',
  SHIPPING = 'SHIPPING',
  MISSING_OR_DAMAGED_PACKAGING = 'MISSING_OR_DAMAGED_PACKAGING',
  OUT_OF_RETURN_PERIOD = 'OUT_OF_RETURN_PERIOD',
  WRONG_ADDRESS_OR_NO_RECEIPT = 'WRONG_ADDRESS_OR_NO_RECEIPT',
  OTHER = 'OTHER',
}
